export default "__VITE_ASSET__4f78a93d__"